import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { Highlighter } from 'react-bootstrap-typeahead'
import styled from 'styled-components'

import Button from '../../../../../../../../1stlog-ui/src/components/Button'
import HazmatLabel from '../../../../../../../components/Hazmat/HazmatLabel'

const Wrapper = styled.div``

export const TypeAheadOption = (props) => {
  const {
    class: classMap,
    classCode: classCodeArray,
    unNumber,
    description,
    transportCategory,
    tunnelLimitation,
    packagingGroup,
    hazardLabels = [],
    searchBy = 'description',
    text,
  } = props

  const classCode = lodash.first(classCodeArray)
  let descriptionComponent = description
  if (searchBy === 'description') {
    descriptionComponent = (
      <Highlighter key="description" search={text}>
        {description}
      </Highlighter>
    )
  }

  return (
    <div style={{ minWidth: '675px' }} className="has-pointer">
      <div className="d-flex" style={{ minWidth: '675px' }}>
        <div style={{ flex: '1 1 0' }}>
          <h6
            className="mt-0 mb-1"
            style={{ whiteSpace: 'normal', aminWidth: '675px' }}
          >
            {description}
          </h6>
          <div>
            <b>{i18n.t('un_nr', 'UN-Nummer')}:</b> {unNumber}
          </div>
          <div>
            <b>{i18n.t('label_class', 'Klasse')}:</b>{' '}
            {lodash.get(classMap, 'key')} ({lodash.get(classMap, 'name')})
          </div>
          {classCode && (
            <div style={{ whiteSpace: 'normal', aminWidth: '675px' }}>
              <b>{i18n.t('label_code', 'Code')}:</b>{' '}
              {lodash.get(classCode, 'key')} ({lodash.get(classCode, 'name')})
            </div>
          )}
        </div>
        <div className="d-flex">
          {lodash.map(lodash.filter(hazardLabels, Boolean), (label) => (
            <HazmatLabel label={label} display="block" size={75} />
          ))}
        </div>
      </div>
      <div className="d-flex">
        <div style={{ flex: '1 1 0' }}>
          <div>
            <b>{i18n.t('tt_packaging_group', 'Verpackungsgruppe')}:</b>{' '}
            {packagingGroup}
          </div>
          <div>
            <b>{i18n.t('tt_transport_category', 'Beförderungskategorie')}:</b>{' '}
            {transportCategory}
          </div>
          <div>
            <b>{i18n.t('tt_tunnel_limit', 'Tunnellimitierung')}:</b>{' '}
            {tunnelLimitation}
          </div>
        </div>
        <div className="d-flex align-items-end ml-2">
          <Button info small>
            {i18n.t('take_over_hazardgoods', 'Dieses Gefahrgut übernehmen')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default TypeAheadOption

export const renderOption = (option, props, searchBy) => (
  <TypeAheadOption {...option} {...props} searchBy={searchBy} />
)
